import { gql } from '@apollo/client';

const REFRESH_SHIPMENT_TRACKING_QUERY = gql`
  query refreshShipmentTracking($input: RefreshShipmentTrackingInput!) {
    refreshShipmentTracking(input: $input) {
      isSuccess
      message
      tracking {
        trackingHistory {
          status
          statusDetails
          statusDate
          location {
            name
            street1
            city
            country
            state
            zip
            phone
            email
          }
        }
      }
    }
  }
`;

export default REFRESH_SHIPMENT_TRACKING_QUERY;
